import { render, staticRenderFns } from "./company-location.vue?vue&type=template&id=5b326d1d&scoped=true&"
import script from "./company-location.vue?vue&type=script&lang=js&"
export * from "./company-location.vue?vue&type=script&lang=js&"
import style0 from "./company-location.vue?vue&type=style&index=0&id=5b326d1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b326d1d",
  null
  
)

export default component.exports